import { ImageLoaderConfig } from '@angular/common';

const PLACEHOLDER_QUALITY = 10;
const IMAGE_DOMAIN_URL = '{host}/cdn-cgi/image/{params}{pathname}';
const SC_MEDIA_BREAK_POINT = '/$-$/';
const SC_MEDIA_URL_HOST = 'scmedia';

export function overrideImageUrl(config: ImageLoaderConfig) {
    const { src = '', isPlaceholder, width } = config;
    try {
        const host = (window as any).clientConfig.csGameConfig.host;
        const isCloudflare = src.includes(host);
        let params = ['format=auto'];
        if (width) params.push(`width=${width}`);
        if (isPlaceholder) params.push(`quality=${PLACEHOLDER_QUALITY}`);

        if (isCloudflare) {
            const url = new URL(src);

            const resultUrl = IMAGE_DOMAIN_URL.replace('{host}', host).replace('{params}', params.join(',')).replace('{pathname}', url.pathname);
            return resultUrl;
        }

        const isSCMediaUrl = src.toLowerCase().includes(SC_MEDIA_URL_HOST);
        if (isSCMediaUrl) {
            const [host, pathname] = src.split(SC_MEDIA_BREAK_POINT);
            let scMediaHost = host + SC_MEDIA_BREAK_POINT;

            const resultUrl = IMAGE_DOMAIN_URL.replace('{host}/', scMediaHost)
                .replace('{params}', params.join(','))
                .replace('{pathname}', `/${pathname}`);
            return resultUrl;
        }

        return src;
    } catch {
        return src;
    }
}
